type Rgba = { red: number; green: number; blue: number; alpha: number };

// Luminância em que preto e branco dão o mesmo contraste (WCAG): abaixo dela o
// branco contrasta mais.
const DARK_LUMINANCE = 0.179;

const RGB_PATTERN =
  /^rgba?\(\s*([\d.]+)[,\s]+([\d.]+)[,\s]+([\d.]+)(?:\s*[,/]\s*([\d.]+%?))?\s*\)$/;

function parseRgb(value: string): Rgba | null {
  const match = RGB_PATTERN.exec(value.trim());
  if (!match) {
    return null;
  }
  const [, red, green, blue, alpha] = match;
  const parsedAlpha =
    alpha === undefined
      ? 1
      : alpha.endsWith('%')
        ? Number(alpha.slice(0, -1)) / 100
        : Number(alpha);
  return { red: Number(red), green: Number(green), blue: Number(blue), alpha: parsedAlpha };
}

function channelLuminance(channel: number): number {
  const srgb = channel / 255;
  return srgb <= 0.03928 ? srgb / 12.92 : ((srgb + 0.055) / 1.055) ** 2.4;
}

function relativeLuminance({ red, green, blue }: Rgba): number {
  return (
    0.2126 * channelLuminance(red) +
    0.7152 * channelLuminance(green) +
    0.0722 * channelLuminance(blue)
  );
}

/**
 * Diz se o fundo que APARECE atrás do elemento é escuro — é o que escolhe entre
 * a marca preta (fundo claro) e a branca (fundo escuro).
 *
 * Sobe pelos ancestrais até a primeira cor de fundo não transparente. A cor do
 * contratante (`branding.backgroundColor`) não serve para isso: ela só pinta o
 * `<body>`, e as telas pintam o próprio fundo por cima dele. Sem cor nenhuma no
 * caminho vale o padrão do funil, que é claro.
 */
export function isOnDarkBackground(element: Element): boolean {
  let current: Element | null = element;
  while (current) {
    const color = parseRgb(window.getComputedStyle(current).backgroundColor);
    if (color && color.alpha > 0) {
      return relativeLuminance(color) < DARK_LUMINANCE;
    }
    current = current.parentElement;
  }
  return false;
}
